module.exports = __webpack_public_path__ + "static/user_group_L-df141eefbd9481c84b3d.png";